module.exports = __webpack_public_path__ + "img/3.d1df0253.png";